import http from '../helpers/http';
import { FilteredOptionsInterface, makeQueryParamsForRequest } from '../entities/FilteredOptions';

const PerformanceFeedback = (token: string) => {
  const headers = {
    'x-access-token': token,
  };

  return {
    create: async (body: any) => {
      const result = await http.post('/performance-feedback', body, { headers });
      return result.data;
    },
    show: async (id: string) => {
      const result = await http.get(`/performance-feedback/${id}`, {
        headers,
      });
      return result.data;
    },
    listByEmployee: async (employeeId: string, filteredOptions?: FilteredOptionsInterface) => {
      const params = makeQueryParamsForRequest(filteredOptions);
      const result = await http.get(`/performance-feedback/by-employee/${employeeId}`, {
        headers,
        params,
      });
      return result.data;
    },
    listBySchool: async (schoolId: string, filteredOptions?: FilteredOptionsInterface) => {
      const params = makeQueryParamsForRequest(filteredOptions);
      const result = await http.get(`/performance-feedback/by-school/${schoolId}`, {
        headers,
        params,
      });
      return result.data;
    },
    getPriorDiscussions: async (userId: string) => {
      const result = await http.get(`/performance-management/by-user/${userId}`, {
        headers,
      });
      return result.data;
    },
    getUserFeedbacks: async (userId: string, type: string = 'feedback') => {
      const result = await http.get(`/performance-management/by-user/${userId}`, {
        headers,
        params: { type },
      });
      return result.data;
    },
    approve: async (id: string) => {
      const result = await http.patch(`/performance-feedback/${id}/approve`, {}, { headers });
      return result.data;
    },
    reject: async (id: string) => {
      const result = await http.delete(`/performance-feedback/${id}/reject`, { headers });
      return result.data;
    },
    delete: async (id: string) => {
      const result = await http.delete(`/performance-feedback/${id}`, { headers });
      return result.data;
    },
    update: async (id: string, body: any) => {
      const result = await http.put(`/performance-feedback/${id}`, body, { headers });
      return result.data;
    },
  };
};

export default PerformanceFeedback;
